import { ActionReducer, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer } from '@contact/upgrade';

import * as fromCobrowsing from './cobrowsing';
import * as fromKnowledgeBase from './knowledge-base';

/**
 * Name store feature
 */
export const featureName = 'agent';

/**
 * Agent state interface
 */
export interface State {
  knowledgeBase: fromKnowledgeBase.KnowledgeBase;
  cobrowsing: fromCobrowsing.CobrowsingSessions;
}

/**
 * Initial Agent state
 */
export const initialState: State = {
  knowledgeBase: fromKnowledgeBase.initialKnowledgeBase,
  cobrowsing: fromCobrowsing.initialCobrowsingSessions,
};

/**
 * Agent reducers map
 */
export const reducers: ActionReducerMap<State> = {
  knowledgeBase: fromKnowledgeBase.reducer,
  cobrowsing: fromCobrowsing.reducer,
};

/**
 * Agent meta reducers array
 */
export function cleanReducer(reducer: ActionReducer<any>) {
  return configureCleanReducer(featureName, {
    initialState,
    keys: [],
  })(reducer);
}
export function syncReducer(reducer: ActionReducer<any>) {
  return configureSyncReducer(featureName, ['cobrowsing'])(reducer);
}
export const metaReducers = [cleanReducer, syncReducer];

/**
 * Memoized selector for Agent model
 */
const getFeature = createFeatureSelector<State>(featureName);
export const getKnowledgeBase = createSelector(getFeature, (state: State) => state.knowledgeBase);
export const getCobrowsing = createSelector(getFeature, (state: State) => state.cobrowsing);

/**
 * Memoized selector for Owi KnowledgeBase model
 */
export const getSuggestedResults = createSelector(getKnowledgeBase, fromKnowledgeBase.KnowledgeBaseSelector.getSuggestedResults);
export const getSearchResults = createSelector(getKnowledgeBase, fromKnowledgeBase.KnowledgeBaseSelector.getSearchResults);
export const getCobrowsingSessions = createSelector(getCobrowsing, fromCobrowsing.CobrowsingSelector.selectEntities);
export const getCobrowsingSessionById = (_id: string) => createSelector(getCobrowsingSessions, sessions => sessions[_id]);
